<template>
  <div class="advertisements">
    <div class="advertisements__header px-5 pt-4 pb-2">
      <a-row type="flex" justify="space-between" align="center">
        <h2>UGC Creators Table</h2>
        <router-link to="/ugc-creators/new">
          <a-button type="primary">Create UGC Creator</a-button>
        </router-link>
      </a-row>

      <Filters />
    </div>
    <a-row>
      <Table :columns="columns" :data="ugc_creators">
        <template v-slot:id="scope">
          <Icon name="Document" class="advertisement__icon" />
          <p>{{ scope.item.id }}</p>
        </template>
        <template v-slot:name="scope">
          {{ scope.item.name }}
        </template>
        <template v-slot:country="scope">
          {{ scope.item.country }}
        </template>
        <template v-slot:gender="scope">
          {{ scope.item.gender }}
        </template>

        <template v-slot:actions="scope">
          <router-link :to="`/ugc-creators/edit/${scope.item.id}`">
            <a-button>Edit</a-button>
          </router-link>
        </template>
      </Table>
    </a-row>
  </div>
</template>

<script>
import { onMounted, onUnmounted, computed } from "vue";
import { useStore } from "vuex";
import Clipboard from "clipboard";
import Table from "@/components/Table/index";
import Icon from "@/components/UI/Icon";
import Filters from "@/components/UGCFilters";

export default {
  components: { Table, Icon, Filters },
  data() {
    return {
      files: null,
      columns: [
        {
          title: "ID",
          dataIndex: "id",
          key: "id",
          style: {
            width: "350px",
            flex: "none",
          },
          class: "open_popover",
          slot: true,
        },
        {
          title: "Name",
          dataIndex: "name",
          key: "name",
          slot: true,
          class: "open_popover",
        },
        {
          title: "Country",
          dataIndex: "country",
          key: "country",
          slot: true,
          class: "open_popover",
        },
        {
          title: "Gender",
          dataIndex: "gender",
          key: "gender",
          slot: true,
          class: "open_popover",
        },
        {
          title: "Actions",
          dataIndex: "actions",
          key: "actions",
          slot: true,
        },
      ],
    };
  },
  methods: {},
  setup() {
    const store = useStore();

    const token = store.state.token;

    onMounted(async () => {
      await store.dispatch("GET_UGC_CREATORS");
      new Clipboard(".btn_copy");
      window.addEventListener("scroll", onScroll);
    });

    onUnmounted(() => {
      store.commit("SET_PAGE", 0);
      store.commit("SET_UGC_CREATORS", null);
      window.removeEventListener("scroll", onScroll);
    });

    const ugc_creators = computed(() => store.state.ugc_creators);

    const onScroll = async () => {
      if (store.state.totalUGC > ugc_creators.value.length) {
        if (
          document.documentElement.scrollHeight ===
          document.documentElement.scrollTop +
            document.documentElement.offsetHeight
        ) {
          await store.dispatch("GET_UGC_CREATORS");
        }
      }
    };

    return { ugc_creators, onScroll, token };
  },
};
</script>

<style scoped>
.advertisements {
}
.advertisements__item__media {
  max-width: 200px;
}
.popover {
  padding: 5px 10px;
}
.popover__url {
  display: block;
  width: 200px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.popover__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}
.popover__body {
  display: grid;
  grid-template-columns: 100px auto;
}
.advertisement__tags {
  position: absolute;
  width: 100%;
  height: 100%;
  display: grid;
  grid-auto-flow: column;
  gap: 5px;
  justify-content: start;
  align-items: center;
  overflow: hidden;
  background-color: #fff;
  padding-top: 5px;
}
.advertisement__tags:hover {
  grid-auto-flow: row;
  height: auto;
  overflow: initial;
  flex-wrap: wrap;
  z-index: 20;
  padding: 10px;
  border: 1px solid rgb(214, 214, 214);
  border-radius: 2px;
}
.advertisement__icon {
  width: 20px;
  margin-right: 7px;
}
.advertisement__logo {
  width: 30px;
  height: 30px;
  margin-right: 10px;
  object-fit: contain;
  object-position: left;
  border-radius: 100%;
}
</style>
